let axios = require('axios')

export default {
  post: function (url, json, onSuccess, onFailure) {
      axios.post(url, json,{})
        .then(function (response) {
          console.log(response)
          onSuccess(response)
        }).catch(function (error) {
          console.log(error.message)
          onFailure(error)
        }
      )
    }

}
